import { render, staticRenderFns } from "./_SimilarPeopleModal.vue?vue&type=template&id=07e060d0&"
import script from "./_SimilarPeopleModal.vue?vue&type=script&lang=js&"
export * from "./_SimilarPeopleModal.vue?vue&type=script&lang=js&"
import style0 from "./_SimilarPeopleModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports